import { ChevronDown } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
export default function ATasteOfItaly() {
  return <section data-section-id="223782" id="il-futuro-dellagricoltura" className="relative flex min-h-[80vh] md:min-h-screen w-full items-center justify-center overflow-hidden text-foreground bg-background">
      {}
      <div className="absolute inset-0 z-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680532/img/tuscan_vineyard_sunrise_mist.png)] transition-transform duration-1000 hover:scale-105" />

      {}
      <div className="absolute inset-0 z-0 bg-slate-900/30 backdrop-blur-[2px]" />

      {}
      <div className="relative z-10 flex flex-col items-center px-2 md:px-4 text-center !text-[rgba(92,191,80,1)] w-full max-w-xs md:max-w-4xl mx-auto">
        <Link to="/" className="mb-6 flex justify-center transition-transform duration-300 hover:scale-105"></Link>

        <h1 className="mb-10 tracking-tighter font-extrabold !text-6xl !font-default md:!text-9xl md:leading-[1]"><span className="!font-extrabold !text-6xl md:!text-9xl !text-[rgba(94,153,186,0.7)]" data-ast-id="f:/src/pages/Home/sections/ATasteOfItaly.tsx|sig:ym4asj" data-ast-start="1170" data-ast-end="1462" style={{
          color: 'rgb(105, 134, 150)'
        }} contenteditable="false">SOLID</span><span className="!font-default !text-[rgba(92,197,80,0.75)]" data-ast-id="f:/src/pages/Home/sections/ATasteOfItaly.tsx|sig:4qvmye" data-ast-start="1462" data-ast-end="1727" style={{
          color: 'rgb(92, 191, 80)'
        }} contenteditable="false">GREEN</span><br /></h1>

        <p className="mb-10 !font-default !text-xl !font-medium !text-[rgba(187,202,216,0.88)] !not-italic">ogni goccia, ogni radice, ogni futuro</p>

        <div className="mb-10 w-full max-w-xl">
          
        </div>

        <Link to="/ProductsPage">
          <Button variant="outline" size="lg" className="rounded-lg border-none bg-secondary px-6 py-4 md:px-10 md:py-7 text-sm uppercase tracking-[0.2em] text-secondary-foreground shadow-lg shadow-secondary/20 transition-all duration-500 hover:scale-105 hover:bg-secondary/90 animate-pulse">
            Scopri i Prodotti
          </Button>
        </Link>
      </div>

      {}
      <div className="absolute bottom-10 left-1/2 z-10 -translate-x-1/2 animate-bounce">
        <ChevronDown className="size-10 text-white/80" strokeWidth={1.5} />
      </div>
    </section>;
}